/**
 * Helper to manage the active store context across the application.
 */

export const ACTIVE_STORE_EVENT = "activeStoreChanged";

export const getActiveStoreId = (): string | null => {
  return localStorage.getItem("activeStoreId");
};

export const setActiveStoreId = (storeId: string) => {
  localStorage.setItem("activeStoreId", storeId);
  window.dispatchEvent(
    new CustomEvent(ACTIVE_STORE_EVENT, { detail: { storeId } })
  );
};

export const onActiveStoreChange = (
  callback: (storeId: string) => void
): (() => void) => {
  const handler = (event: any) => {
    callback(event.detail?.storeId || getActiveStoreId() || "");
  };
  window.addEventListener(ACTIVE_STORE_EVENT, handler);
  return () => {
    window.removeEventListener(ACTIVE_STORE_EVENT, handler);
  };
};
